import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from '../../base/api-service-base';
import { OrderDeliveryStatusReferenceModel } from "../../models/reference-model/reference-general-model/order-delivery-status-reference.model";

@Injectable({
  providedIn: 'root'
})
export class OrderDeliveryStatusReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/OrderDeliveryStatusReferences";

  constructor(private httpClient: HttpClient,
    private authService: AuthService) {
      super(httpClient, authService);
  }

  public getOrderDeliveryStatusReference(): Observable<OrderDeliveryStatusReferenceModel[]> {
    return this.httpGet<OrderDeliveryStatusReferenceModel[]>(this.PATH, null)
      .pipe(
        map(
          response => response.body
        )
      )
  }
}
